<template>
  <div id="app">
    <FirstCompoents :name="menuname" />
    <!-- <div id="scroller-wrapper" data-scrollbar> -->
      <Homecomponent></Homecomponent>
      <!-- <FootCompoents /> -->
    <!-- </div> -->

    
  </div>
</template>

<script>
// import Scrollbar from "smooth-scrollbar";
import FirstCompoents from "../../components/first";
import Homecomponent from "../../views/home";
import { WOW } from "wowjs";
export default {
  name: "home",
  data() {
    return {
      menuname:'index',
      phoneMenuShow: true,
    }; 
  },
  components: { Homecomponent, FirstCompoents },
  mounted() {
    var wow = new WOW();
     wow.init();
   
    // Scrollbar.init(document.querySelector("#scroller-wrapper"));
  },
  methods: {},
};
</script>
<style>
body {
  margin: 0;
  padding: 0;
}
ul,
li,
p,
a {
  margin: 0;
  padding: 0;
  text-decoration: none;
  color: black;
}
#app{
  overflow: hidden;
}
#scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
    overflow-x: hidden;
    touch-action: none
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #98A48E!important;
  }
  .scrollbar-track-x{
  display: none;
}
  .scrollbar-track-y{
    width:3px !important;
  }
</style>
